import React, { memo } from "react";
import { FileOutlet } from "./FileOutlet";

interface BookOutletProps {
    search?: "global" | "local" | "none";
    match?: "any" | "exact";
}

export const BookOutlet = memo(function BookOutlet({ search = "none", match }: BookOutletProps): React.ReactElement {
    return <FileOutlet search={search} source="book" match={match} />;
});
